import { Routes } from '@angular/router';
import { organizationGuard } from '@core/auth/organization.guard';
import { roleGuard } from '@core/auth/role.guard';
import { ModuleRole } from '@core/domain/module-role';
import { DcIcons } from '@ui/app-console.icons';

import {
	ACCOUNT_PATH,
	ADMIN_PATH,
	GROUPS_PATH,
	MODULES_PATH,
	ROOT_ORGANIZATION_PATH,
	USERS_PATH,
} from './constants';

export type Feature = 'modules' | 'users' | 'groups' | 'admin';

export const routes: Routes = [
	{
		path: `${MODULES_PATH}`,
		data: {
			featureName: 'modules',
			iconName: DcIcons.ProductsInstances,
			isPrincipalNav: true,
			roles: [ModuleRole.OrganizationAdmin],
			preload: false,
		},
		loadChildren: () =>
			import('./features/module/module.routes').then((m) => m.MODULE_ROUTES),
		canActivate: [roleGuard()],
	},
	{
		path: `${USERS_PATH}`,
		data: {
			featureName: 'users',
			iconName: DcIcons.UsersFeature,
			isPrincipalNav: true,
			roles: [ModuleRole.OrganizationAdmin],
		},
		loadChildren: () =>
			import('./features/user/user.routes').then((m) => m.USER_ROUTES),
		canActivate: [roleGuard()],
	},
	{
		path: `${GROUPS_PATH}`,
		data: {
			featureName: 'groups',
			iconName: DcIcons.GroupsFeature,
			isPrincipalNav: true,
			roles: [ModuleRole.OrganizationAdmin],
		},
		loadChildren: () =>
			import('./features/group/group.routes').then((m) => m.GROUP_ROUTES),
		canActivate: [roleGuard()],
	},
	{
		path: `${ADMIN_PATH}`,
		data: {
			featureName: 'admin',
			iconName: DcIcons.RoleAdminOrg,
			isPrincipalNav: true,
			roles: [ModuleRole.OrganizationAdmin],
		},
		loadChildren: () =>
			import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
		canActivate: [roleGuard()],
	},
];

export const parentRoute: Routes = [
	{
		path: `${ROOT_ORGANIZATION_PATH}/:orgId`,
		children: routes,
		canActivate: [organizationGuard()],
	},
	{
		path: ACCOUNT_PATH,
		data: {
			featureName: $localize`:i18n=@@feature.account:`,
			iconName: DcIcons.Account,
			isPrincipalNav: false,
		},
		loadChildren: () =>
			import('./features/account/profil.routes').then((m) => m.ACCOUNT_ROUTES),
	},
	{
		path: '**',
		redirectTo: ACCOUNT_PATH,
		pathMatch: 'full',
	},
];
